/**
 * Created by admin on 2017/1/12.
 */
import 'whatwg-fetch';
import { encryptRsa, encryptAllRsa, encryptAesKey, encryptAesUuid, encryptAes, decryptAes } from './encrypt';


/**
 * get请求 敏感信息
 * @param  {String} options.url   api地址
 * @param  {String} options.query query参数
 * @return {Promise}               Promise
 */
export const _getAes = async (url) => {
    let UserKey = await encryptAesKey();
    let UserUuid = await encryptAesUuid();
    return fetch(url,{
        credentials: 'include',
        headers : {
            'User-key' : UserKey,
            'User-uuid' : UserUuid,
        }
    })
        .then( async (res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

/**
 * post请求，敏感数据需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _postAes = async (url, params) => {
    let UserKey = await encryptAesKey();
    let UserUuid = await encryptAesUuid();
    let data = corvent(params) ? 'encryptionData=' + await encryptAes(corvent(params)) : corvent(params);
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept' : 'application/json',
            'User-key' : UserKey,
            'User-uuid' : UserUuid,
        },
        credentials: 'include',
        mode: 'cors',
        body: data
    }).then( async (res) => {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return Promise.reject(new Error(res.status));
    });
};

/**
 * post请求，敏感信息需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _postEncrypt = async (url, params) => {
    let UserKey = await encryptAesKey();
    let UserUuid = await encryptAesUuid();
    let data = 'encryptionData=' + await encryptAes(corvent(params));
    return fetch(url, {
        method: 'POST',
        headers: {
            'User-key' : UserKey,
            'User-uuid' : UserUuid,
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept' : 'application/json',
        },
        credentials: 'include',
        mode: 'cors',
        body: data
    }).then((res) => {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return Promise.reject(new Error(res.status));
    });
};

/**
 *  POST 敏感信息数据无需加密
 * @param {*} url
 * @param {*} params
 */
export const _postNoEncryptAes = async (url, params) => {
    let UserKey = await encryptAesKey();
    let UserUuid = await encryptAesUuid();
    let data = 'encryptionData=' + await encryptAes(corventNoEncrypt(params));
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept' : 'application/json',
            'User-key' : UserKey,
            'User-uuid' : UserUuid,
        },
        credentials: 'include',
        mode: 'cors',
        body: data
    })
        .then(async (res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

/**
 * post请求 -json 敏感信息
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _postJsonAes = async (url, params) => {
    let UserKey = await encryptAesKey();
    let UserUuid = await encryptAesUuid();
    let data = {
        encryptionData : await encryptAes(JSON.stringify(params))
    };
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept' : 'application/json',
            'User-key' : UserKey,
            'User-uuid' : UserUuid,
        },
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify(data)
    })
        .then(async (res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};


/**
 * get请求
 * @param  {String} options.url   api地址
 * @param  {String} options.query query参数
 * @return {Promise}               Promise
 */
export const _get = (url) => {

    return fetch(url,{
        credentials: 'include',
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

export const _postFile = (url, formData) => {
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'no-cors',
        body: formData
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

/**
 * post请求，数据需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _post = (url, params) => {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept' : 'application/json',
        },
        credentials: 'include',
        mode: 'no-cors',
        body: corvent(params)
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};


/**
 *  POST 数据无需加密
 * @param {*} url
 * @param {*} params
 */
export const _postNoEncrypt = (url, params) => {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept' : 'application/json',
        },
        credentials: 'include',
        mode: 'no-cors',
        body: corventNoEncrypt(params)
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

/**
 * post请求 -json
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _postJson = (url, params) => {

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept' : 'application/json',
        },
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify(params)
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};

function isString(str){ //判断是否为 String串
    return (typeof str=='string')&&str.constructor==String;
}

/**
 * 转换json参数格式（加密）
 * @param params
 */
function corvent(params) {
    var result = '';
    if(params){
        for (var jsonStr in params) {
            let value = params[jsonStr];
            result += jsonStr + '=' + value + '&';
        }
        if (result.length > 0){
            result = result.substring(0,result.length-1);
        }
    }
    let encryptResult = '';
    if(result){//加密整个串
        encryptResult = encryptAllRsa(result);
        if(encryptResult){
            encryptResult = 'data=' + encryptResult;
        }
    }
    // console.log(1,'加密前数据为',JSON.stringify(params),2,'加密后数据为',encryptResult);
    return encryptResult;
}

/**
 *  转换参数不加密
 * @param {*} params
 */
function corventNoEncrypt(params) {
    var result = '';
    if(params ){
        for (var jsonStr in params) {
            result += jsonStr + '=' + params[jsonStr] + '&';
        }
        if (result.length > 0){
            result = result.substring(0,result.length-1);
        }
    }
    // console.log(result);
    return result;
}


/**
 * post请求，数据单独需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
export const _postCors = (url, params) => {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept' : 'application/json',
        },
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify(params)
    })
        .then((res) => {
            if (res.status >= 200 && res.status < 300) {
                return res.json();
            }
            return Promise.reject(new Error(res.status));
        });
};




// WEBPACK FOOTER //
// ./src/utils/http.js